import {
  createMovieGridItem,
  createReviewsDiv,
  createSimilarMoviesDiv,
  createVideosDiv,
} from "./domUtils";
import { getAdditionalMovieInfo } from "./MovieSearch";
import { appState } from "./state";
import { Movie } from "./types";
import {
  constructPosterUrl,
  extractYearOfReleaseFromDate,
  getMovieGenres,
} from "./utils";

export const costructAdditionalInfoDiv = (movieId: number) => {
  try {
    const panel = document.createElement("div");
    panel.classList.add("movie__movie-additional-info");

    return panel;
  } catch (err) {
    console.error("Failed to fetch extras", movieId, err);
  }

  return;
};

export function renderMovies(movies: Movie[], replace = false) {
  const container = document.querySelector(".movie-container");

  if (!container) return;

  if (replace) container.innerHTML = "";
  for (const movie of movies) {
    const movieGenres = getMovieGenres(movie);
    const movieDiv = createMovieGridItem(
      movie.id,
      movie.title,
      movie.overview,
      constructPosterUrl(movie.poster_path, true),
      movieGenres,
      extractYearOfReleaseFromDate(movie.release_date),
      movie.vote_average,
    );
    container.appendChild(movieDiv);
  }
}

export const createMovieGrid = async () => {
  await appState.setGenres();
  const mainContainer = document.querySelector(".main-content");

  if (document.getElementById("currentMoviesContainer")) return;

  const movieContainer = document.createElement("div");
  movieContainer?.classList.add("movie-container");
  movieContainer.id = "currentMoviesContainer";

  mainContainer?.appendChild(movieContainer);

  let activeController: AbortController | null = null;

  const movieClickHandler = async (e: Event) => {
    activeController?.abort();
    activeController = new AbortController();

    const { signal } = activeController;

    const target = e.target as HTMLElement | null;
    const card = target?.closest<HTMLDivElement>(".movie");

    if (!card || !movieContainer.contains(card)) return;

    if (card.classList.contains("expand")) {
      document.startViewTransition(() => {
        card.classList.remove("expand");
      });
      return;
    }

    const additionalInfoPanel = card?.querySelector(
      ".movie__movie-additional-info",
    );
    additionalInfoPanel!.innerHTML =
      "<p style='width: 400px; font-size:34px; font-weight: bold'>Loading...</p>";
    const additionalMovieInfo = await getAdditionalMovieInfo(parseInt(card.id));

    if (signal.aborted) return;
    if (!additionalMovieInfo) return;

    const { videos, reviews, similarMovies } = additionalMovieInfo;
    const reviewsDiv = createReviewsDiv(reviews.results);
    const videosDiv = createVideosDiv(videos.results);
    const similarMoviesDiv = createSimilarMoviesDiv(similarMovies.results);

    if (!additionalInfoPanel) return;
    additionalInfoPanel.innerHTML = "";
    additionalInfoPanel.prepend(reviewsDiv);
    additionalInfoPanel.prepend(videosDiv);
    additionalInfoPanel.prepend(similarMoviesDiv);

    document.startViewTransition(() => {
      // document.querySelectorAll(".movie").forEach((movie, index) => {
      //   (movie as HTMLElement).style.viewTransitionName = `movie-${index}`;
      // });
      card.classList.toggle("expand");
    });
  };

  movieContainer.addEventListener("click", movieClickHandler);

  (movieContainer as any)._hasMovieClickHandler = true;
};
